import { ThemeProvider } from "react-bootstrap";
import { WorkflowProvider } from "../../context/WorkflowContext";

import Filter from "./Filter";
import Results from "./Results";

import {
    StyledBody,
    StyledHeader,
    StyledTitle,
    StyledSubTitle,
} from "../../styles/MainStyles";
import { StyledCardGrey } from "../../styles/pages/Schedule/ModalViewDetailsStyles";
import { TachDocumentProvider } from "../../context/TachDocumentContext";

const Workflows = () => {
    return (
        <WorkflowProvider>
            <TachDocumentProvider>
                <ThemeProvider theme={{}}>
                    <StyledHeader>
                        <StyledTitle>Aprovações</StyledTitle>
                        <StyledSubTitle>
                            Nesse espaço você pode analisar fluxos e
                            solicitações.
                        </StyledSubTitle>
                    </StyledHeader>
                    <StyledBody>
                        <StyledCardGrey body>
                            <Filter />
                            <Results />
                        </StyledCardGrey>
                    </StyledBody>
                </ThemeProvider>
            </TachDocumentProvider>
        </WorkflowProvider>
    );
};

export default Workflows;
